import { render } from "./VideoSection.vue?vue&type=template&id=95848d1a&scoped=true&ts=true"
import script from "./VideoSection.vue?vue&type=script&lang=ts"
export * from "./VideoSection.vue?vue&type=script&lang=ts"

import "./VideoSection.vue?vue&type=style&index=0&id=95848d1a&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95848d1a"]])

export default __exports__